import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 20C2.45 20 1.97933 19.8043 1.588 19.413C1.196 19.021 1 18.55 1 18V6C1 5.45 1.196 4.97933 1.588 4.588C1.97933 4.196 2.45 4 3 4H9L11 6H19C19.55 6 20.021 6.196 20.413 6.588C20.8043 6.97933 21 7.45 21 8H10.175L8.175 6H3V18L5.4 10H22.5L19.925 18.575C19.7917 19.0083 19.546 19.3543 19.188 19.613C18.8293 19.871 18.4333 20 18 20H3ZM5.1 18H18L19.8 12H6.9L5.1 18Z",
		fill: "currentColor"
	})
});
export default SvgFolderOpen;
